<template>
  <div class="p-pnt">
    <ModalError :visible="showModalError" :errorType="errorType" ></ModalError>
    <div class="l-container sm-default-px">
      <!-- <div class="c-box mb-16 mt-px"> -->
      <Header v-model="menuBasicInfo" :bodyEmail="bodyEmail"/>
      <MenuNavigation :isRakutenFlg="isRakutenFlg" />
      <router-view></router-view>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import Header from './Header'
import MenuNavigation from './MenuNavigation'

import mark_watched from '@/mixins/mark_watched'
import { BREADCRUMBS } from '@/store/modules/app/actions'

export default {
  name: 'MenuMainContainer',
  components: {
    Header,
    MenuNavigation
  },
  mixins: [mark_watched],
  data() {
    return {
      showModalError: false,
      errorType: '',
      menuBasicInfo: null,
      isRakutenFlg: false,
      bodyEmail:{
        memberName: '',
        menuNo: '',
        menuNm: '',
        planId: '',
        roomId: '',
        planNm: ''
      }
    }
  },
  created() {
    this.getMenuBasicInfo()
  },
  mounted() {},
  watch: {
    /** ルートごとに異なるタイトルをセットする */
    watchDocumentTitleTargets() {
      if (this.menuBasicInfo == null) return
      switch (this.$route.name) {
      case 'Menu Detail':
        document.title = `${this.menuBasicInfo.menuNm}｜割引・特別優待ならベネフィットステーション`
        break
      case 'MenuPlanList':
        document.title = `${this.menuBasicInfo.menuNm}｜割引・特別優待ならベネフィットステーション`
        break
      case 'plan_details':
        this.$meta.setDocumentTitle(`メニュー「${this.menuBasicInfo.menuNm}」（プラン詳細）`)  
        break
      }
    },
    //queryが変わった時にパンくずのリンクに反映する
    '$route.query': {
      handler: "getMenuBasicInfo",
    }
  },
  computed: {
    /**
     * titleタグをルートごとに変更するため、以下の２つをwatch対象にする
     * 1 メニュー名（menuNm）を保持しているmenuBasicInfo
     * 2 現在のルート名
     * */
     watchDocumentTitleTargets() {
      return [this.menuBasicInfo, this.$route]
    }
  },
  methods: {
    getBodyEmail() {
      this.bodyEmail = {
        memberName: _.get(this.$store, 'getters.bs_app.info_user.username', ''),
        menuNo: _.get(this.menuBasicInfo, 'menuInformation.menuNo', null),
        menuNm: _.get(this.menuBasicInfo, 'menuInformation.menuNm', null),
        planId: _.get(this.menuBasicInfo, 'planBasicInfo.planId', null),
        roomId: _.get(this.menuBasicInfo, 'roomBasicInfo.roomId', null),
        planNm: _.get(this.menuBasicInfo, 'planBasicInfo.planNm', null)
      }
    },

    getMenuBasicInfo() {
      const { menuNo } = this.$route.params
      this.$loading.show()
      this.$repositories('menu')
        .getMenuBasicInfo(menuNo)
        .then(
          (result) => {
            this.menuBasicInfo = result.data
            this.getBodyEmail();
            // update breadcrumbs
            const breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
            if (breadcrumbs.length < 3) {
              breadcrumbs.push({
                path: `/menus/${menuNo}`,
                query: this.$route.query,
                title: _.get(this.menuBasicInfo, 'menuNm', '')
              })
            }
            this.$store.dispatch(BREADCRUMBS, breadcrumbs)

            // 楽天の場合は、フォトギャラリーを非表示にする(初回リリース時対応)
            if (this.menuBasicInfo.extSystemCd == 'RakutenT') {
              this.isRakutenFlg = true;
            }
            this.$loading.hide()
          },
          (error) => {
            this.$loading.hide()
            if (error && error.status == 401) {
              this.showModalError = true
            }
          }
        )
    }
  }
}
</script>